import angular from 'angular';

export class SearchHistoryComponent {
    /* @ngInject */
    constructor($stateParams) {
        const searchMainCtrl = this;

        searchMainCtrl.data = {
            currSearchHistoryIndex: $stateParams.currSearchHistoryIndex,
            currCandidatePage: $stateParams.currCandidatePage,
            talentID: $stateParams.talentID,
            scroll: $stateParams.scroll,
            searchName: $stateParams.searchName,
            showView: 'MainSearch',
            candidatesName: $stateParams.candidatesName,
        };
    }
}

export const SearchHistoryComponentConfiguration = {
    template: '<search-component search-data="searchMainCtrl.data"></search-component>',
    controller: SearchHistoryComponent,
    controllerAs: 'searchMainCtrl',
};

angular.module('TALENYA-FE').component('searchHistory', SearchHistoryComponentConfiguration);
